import { DateType } from "data/types/index";
import urlFilter from "../../filters/url.filter";
import { parseDate } from "../../utilities/parseHelper";

/** Общая модель операции для выписок и истории операций */
export class StatementItemModel {
  /** Дата для отображения */
  public Date: DateType = new Date();

  /** Картинка для отображения */
  public Picture: string = "";

  /** Описание для отображения */
  public Description: string = "";
  
  /** Описание отказа по операции*/
  public DenialRequest: string = "";
  
  /** Состояние для отображения */
  public RequestState: number = 0;

  /** Сумма операции для отображения */
  public Sum: number = 0;

  /** Валюта для отображения */
  public Currency: string = "";

  /** Категория для отображения */
  public Category: string = "";

  public Id: number = 0;

  public IsSbp: boolean = false;

  public ReferenceId: number | string = '';

  public ContractAlias: string = "";

  public IsRespondentActive: boolean = false;

  public Color: string = "";

  public Status: number = 0;

  public modalDetails: any = null;

  public sbpDetails: any = null;

  constructor(
    date: DateType,
    pict: string,
    desc: string,
    reqState: number,
    sum: number,
    curr: string,
    category: string,
    id: number = 0,
    ref: number | string = '',
    contract: string = "",
    isRespActive: boolean = false,
    color: string = "",
    status: number = 0,
    modalDetails: any = null,
    sbpDetails: any = null,
    isSbp: boolean = false,
    denialRequest: string = ""
  ) {
    this.Date = parseDate(date);
    this.Picture = urlFilter(pict);
    this.Description = desc;
    this.RequestState = reqState;
    this.Sum = sum;
    this.Currency = curr;
    this.Category = category;
    this.Id = id;
    this.Status = status;
    this.ReferenceId = ref;
    this.ContractAlias = contract;
    this.IsRespondentActive = isRespActive;
    this.Color = color;
    this.modalDetails = modalDetails;
    this.sbpDetails = sbpDetails;
    this.IsSbp = isSbp;
    this.DenialRequest = denialRequest;
  }
}
